import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";
import { getStockByIdAndBranch } from "../../../../../Stock/StockAnalysis/Redux/api";

// get purchaseReturnBranch
export const getPurchaseReturnBranch = createAsyncThunk(
  "purchaseReturnBranch/getPurchaseReturnBranch",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getPurchaseReturnBranch({ rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all purchaseReturnBranch
export const getAllPurchaseReturnBranch = createAsyncThunk(
  "purchaseReturnBranch/getAllPurchaseReturnBranch",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllPurchaseReturnBranch();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("purchaseReturnBranch/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("purchaseReturnBranch/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "purchaseReturnBranch/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePurchaseReturnBranch({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get item by id
export const getPurchaseReturnBranchById = createAsyncThunk(
  "purchaseReturnBranch/getPurchaseReturnBranchById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseReturnBranchById(id);

      if (data?.data?.salesOrderMain?.saleDetails?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data?.data?.salesOrderMain?.saleDetails?.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return {
          ...data,
          data: { ...data.data, salesOrderMain: { ...data.data.salesOrderMain, saleDetails: updatedDetails } },
        };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getPurchaseInvoiceDetail = createAsyncThunk(
  "purchaseReturnBranch/getPurchaseInvoiceDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseInvoiceDetail(id);

      if (data?.data.purchaseInvoiceDetail?.length > 0) {
        // get stock by id and branch
        const updatedDetailsPromises = data.data?.purchaseInvoiceDetail.map(async (detail) => {
          const { data: stockData } = await getStockByIdAndBranch(detail?.product?.id, data?.data.branch?.id); // getStockByIdAndBranch

          if (stockData.data?.length > 0) {
            return {
              ...detail,
              // availableStock stock from stockData
              availableStock: stockData.data[0]?.closingStock || "",
            };
          } else {
            return {
              ...detail,
              availableStock: 0,
            };
          }
        });

        const updatedDetails = await Promise.all(updatedDetailsPromises);
        return { ...data, data: { ...data.data, purchaseInvoiceDetail: updatedDetails } };
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

export const getPurchaseReturnBranchAdditionalChargeList = createAsyncThunk(
  "purchaseReturnBranch/getPurchaseReturnBranchAdditionalChargeList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseReturnBranchAdditionalChargeList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// create purchaseReturnBranch
export const createPurchaseReturnBranch = createAsyncThunk(
  "purchaseReturnBranch/createPurchaseReturnBranch",
  async (createData, { rejectWithValue }) => {
    const {
      purchaseOrderInvoice,
      branch,
      refundAmount,
      grandTotal,
      vatAmount,
      purchaseOrderReturnDetails,
      purchaseOrderReturnAdditionalChargeCost,
      purchaseOrderReturnMainPartyDetails,
      purchaseOrderReturnMainVehicleDetail,
    } = createData;
    try {
      const body = JSON.stringify({
        branch,
        refundAmount,
        purchaseOrderInvoice,
        grandTotal,
        vatAmount,
        purchaseOrderReturnDetails,
        purchaseOrderReturnAdditionalChargeCost,
        purchaseOrderReturnMainPartyDetails,
        purchaseOrderReturnMainVehicleDetail,
      });

      const { data } = await API.createPurchaseReturnBranch(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updatePurchaseReturnBranch = createAsyncThunk(
  "purchaseReturnBranch/updatePurchaseReturnBranch",
  async (params, { rejectWithValue }) => {
    const { id, values } = params;
    const {
      purchaseOrderInvoice,
      purchaseReturnBranchNo,
      status,
      branch,
      refundAmount,
      grandTotal,
      vatAmount,
      purchaseOrderReturnDetails,
      purchaseOrderReturnMainPartyDetails,
      purchaseOrderReturnMainVehicleDetail,
    } = values;
    try {
      const body = JSON.stringify({
        purchaseOrderInvoice,
        purchaseReturnBranchNo,
        status,
        branch,
        refundAmount,
        grandTotal,
        vatAmount,
        purchaseOrderReturnDetails,
        purchaseOrderReturnMainPartyDetails,
        purchaseOrderReturnMainVehicleDetail,
      });
      const { data } = await API.updatePurchaseReturnBranch(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const approvePurchaseReturnBranch = createAsyncThunk(
  "purchaseReturnBranch/approvePurchaseReturnBranch",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.approvePurchaseReturnBranch(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const cancelPurchaseReturnBranch = createAsyncThunk(
  "purchaseReturnBranch/cancelPurchaseReturnBranch",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.cancelPurchaseReturnBranch(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "purchaseReturnBranch/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
